import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-petition-main',
		path: '/admin/p/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_petition_main" */ './index'), {
			exportName: 'AdminPetitionMain',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['support', 'campaigns', 'product', 'engineering'],
		},
		frame: {
			header: true,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
